var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',{class:_vm.justify,style:({
      fontSize: _vm.font_size + 'em',
      fontWeight: _vm.font_weight,
      fontStyle: _vm.font_style,
    }),on:{"click":function($event){return _vm.$emit('editable-paragraph', true)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }